const typoUserMyAccount = {
  title: 'Minha Conta',
  config: 'Configurações',
  profileError: 'Aguarde o arquivo subir',
  name: 'Nome',
  password: 'Senha',
  label: 'Receber emails automáticos',
  automaticEmailsHelperTitle: 'Esta configuração controla o recebimento dos seguintes emails:',
  automaticEmailsHelperWeeklyServicesReport: 'Relatório semanal de serviços',
  automaticEmailsHelperWeeklyActionsReport: 'Relatório semanal de ações',
  automaticEmailsHelperActionCompleted: 'Conclusão da ação, para o criador dela (e administradores, com a feature flag ativa)',
  automaticEmailsHelperActionAssigned: 'Criação da ação, para os responsáveis dela',
  coordinatesLabel: 'Mostrar coordenadas, mapa e data de criação no relatório do serviço',
};

export default typoUserMyAccount;
